import { carousel } from './modules/carousel'
import { headerMenu } from './modules/headerMenu'
import { smoothScroll } from './modules/smoothScroll'
import { tabSwitch } from './modules/tabSwitch'
import { zoomModal } from './modules/zoomModal'
import { stickys } from './modules/stickys'
import { fadeIn } from './modules/fadeIn'

// Carousel初期化
carousel()

// ヘッダーメニュー初期化
headerMenu()

// スムーススクロール初期化
smoothScroll()

// タブ切り替え初期化
tabSwitch()

// ズームモーダル初期化（SPのみ）
zoomModal()
// スティッキースクロール初期化
stickys()

// フェードインアニメーション初期化
fadeIn()
